import defaultClient from '@/plugins/axios/defaultClient'

export default {
  getAgreements() {
    return defaultClient.get('/agreements/')
  },
  postAgreements(agreements) {
    return defaultClient.post('/agreements/', agreements)
  },
  getAgreementsStatus() {
    return defaultClient.get('/agreements/status/')
  },
}
